var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForeignAgentCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 15,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#898991",
    opacity: 0.95
  }, "\u2116XXX")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeignAgentCode);
export default __webpack_public_path__ + "static/media/foreign-agent-code.d3df1685bde9034fdcf76bc347f3f852.svg";
export { ForwardRef as ReactComponent };